<template lang="pug">
  #reset-password
    HeaderForLogin
    h2.font-weight-bold.text-muted.text-center クラウド版サポートサイト パスワードリセット
    b-card.mx-auto.body-width.mt-4(body-class="px-5")
      .form-box.mx-auto
        b-form-text.mt-2.text-left パスワードリセットURLが記載されたメールを送信いたします。
        div(v-if="error_msg_list.length > 0")
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg, error_key) of error_msg_list", :key="error_key") {{error_msg}}
        b-form.text-center(@submit.prevent="send")
          b-form-group.mt-4
            b-container
              b-row
                b-col
                  b-form-input.mt-1(v-model="domain_name.value", required, placeholder="サブドメイン名", :state="domain_name.error_messages.length === 0 ? null : false")
                b-col
                  b-form-radio-group.radio-align-left.domain-name-font-size(v-model="domain_select.value", :checked="domain_select.options[0].value", :state="domain_select.error_messages.length === 0 ? null : false")
                    b-form-radio(:value="domain_select.options[0].value") {{domain_select.options[0].name}}
                    b-form-radio(:value="domain_select.options[1].value") {{domain_select.options[1].name}}
            b-form-text.align-left.text-left.error-message-color(v-for="(message, key) of domain_name.error_messages", :key="key") {{message}}
            b-form-text.align-left.text-left.error-message-color(v-for="(message, key) of domain_select.error_messages", :key="key") {{message}}
            sub-domain-tool-tips.text-left
          b-form-group.mt-2
            b-form-input.mt-1(v-model="mail_address.value", placeholder="メールアドレス")
            b-form-text.text-left ※ご登録または、ご契約時に登録いただいたメールアドレスをご入力してください。
            b-form-text.align-left.text-left.error-message-color(v-for="(message, key) of mail_address.error_messages", :key="key") {{message}}
          b-button.w-100.mt-2.mb-3(type="submit", variant="primary", :disabled="isSubmitButtonDisabled") 申し込む
          router-link(:to="{name: 'Login'}") ログイン画面に戻る
</template>

<script>
import Api from "@/repositories/api"
import HeaderForLogin from "@/components/supportSite/HeaderForLogin";
import SubDomainToolTips from "@/components/supportSite/SubDomainToolTips";

const S208PasswordReset = Api.get("s208PasswordReset")

export default {
  name: "ResetPassword",
  components: {
    HeaderForLogin,
    SubDomainToolTips
  },
  data() {
    return {
      domain_name: {
        value: "",
        error_messages: [],
      },
      mail_address: {
        value: "",
        error_messages: [],
      },
      domain_select: {
        value: "0",
        options: [
          { value: "0", name: ".dn-cloud.com" },
          { value: "1", name: ".chatluck.net" }
        ],
        error_messages: [],
      },

      error_msg_list: [],

      // 送信ボタン用フラグ
      isSubmitButtonDisabled: false
    }
  },
  methods: {
    send() {
      // エラーメッセージ初期化
      this.error_msg_list = [];
      this.domain_name.error_messages = [];
      this.domain_select.error_messages = [];
      this.mail_address.error_messages = [];

      // リクエストデータ作成
      let requestData = {
        subdomain_name: this.domain_name.value,
        subdomain_type: this.domain_select.value,
        e_mail: this.mail_address.value
      };

      // 送信ボタンをロックする
      this.isSubmitButtonDisabled = true

      // パスワードリセット情報登録呼び出し
      S208PasswordReset.add(requestData)
      // 登録成功
      .then(() => {
        // パスワードリセット受付画面へ遷移する
        this.$router.push({
          name: "AcceptResetPassword",
          params: {
            e_mail: this.mail_address.value
          }
        })
      })
      // 失敗
      .catch((error) => {
        // 送信ボタンのロックを解除する
        this.isSubmitButtonDisabled = false

        // 共通のエラー処理
        this.apiError(error, "登録処理")

        // バリデーションエラー
        if (error.response.data && error.response.data.error_list) {
          for (let errorData of error.response.data.error_list) {
            switch(errorData.target){
              // サブドメイン名のエラーメッセージの場合
              case 'subdomain_name':
                this.domain_name.error_messages.push(errorData.error_msg)

                break
              // サブドメイン種別のエラーメッセージの場合
              case 'subdomain_type':
                this.domain_select.error_messages.push(errorData.error_msg)

                break
              // メールアドレスのエラーメッセージの場合
              case 'e_mail':
                this.mail_address.error_messages.push(errorData.error_msg)

                break
              // その他(データ無し等)
              default:
                // 改行がある場合は、分ける
                for (let errorMessageRow of errorData.error_msg.split('\\n')) {
                  this.error_msg_list.push(errorMessageRow)
                }
            }
          }
        }
        // その他エラー
        else {
          this.error_msg_list.push(error)
        }
      })
    }
  }
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
}
.form-box {
  max-width: 540px;
}
.white-space {
  white-space: pre-wrap;
}
</style>